/**
 * Generates avatar initials from a given name.
 * It takes the first letter of the first two words of the name, capitalizes them, and joins them.
 * If the name is empty or not provided, it returns an empty string.
 *
 * @param {string} name - The full name to generate initials from.
 * @returns {string} The generated initials (up to 2 characters) or an empty string.
 */
export default function getAvatarInitials(name) {
  if (!name) return "";

  // Trim leading/trailing spaces and split by one or more spaces
  const nameParts = name.trim().split(/\s+/);
  const initials = nameParts
    .map((part) => part.charAt(0).toUpperCase())
    .slice(0, 2)
    .join("");

  return initials;
}
